import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRenditionPropertyList extends Layout {
    sourceRenditionProperties: DataSource;
    tableProps: Table;
}
